import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useEditAdminSpamAccountMutation } from "@/redux/services/adminSpamAccountsApi"
import { setToast } from "@/redux/toastSlice"
import type { EditSpamAccountPayload } from "@/types/entities/spam-account"

export const useEditSpamAccount = () => {
  const dispatch = useAppDispatch()
  const [editSpamAccount, response] = useEditAdminSpamAccountMutation()

  const handleEditSpamAccount = async ({
    id,
    body,
  }: {
    id: string
    body: EditSpamAccountPayload
  }) => {
    try {
      const response = await editSpamAccount({ body, id }).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success edit account",
          }),
        )
      }
      return response
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(error)
    }
  }

  return { editSpamAccount: handleEditSpamAccount, response }
}
